import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDisabledOuterScroll]'
})
export class DisabledOuterScrollDirective {

  @HostListener('mousewheel', ['$event'])mousewheel() {
    const nativeEl = this.el.nativeElement;
    nativeEl.addEventListener('mousewheel', event => {
      const direction = event.deltaY >= 0 ? 'down' : 'up';
      if (
        ( direction === 'down'	&& nativeEl.scrollTop === (nativeEl.scrollHeight - nativeEl.clientHeight) ) ||
        ( direction === 'up'	&& nativeEl.scrollTop === 0 )
      ) {
        event.preventDefault();
      }
    });
  }

  constructor(
    private el: ElementRef
  ) {}

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/disabled-outer-scroll.directive.ts